import { useEffect, useState } from "react";
import { fetchUnpostedInvoices, updateInvoicePostedStatus, updateInvoiceHeader,updateCancelInvoiceStatus } from "../Api/ViewPostedInvoice";
import { Container, Table, Button, Modal, Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { FaPencilAlt, FaCheck, FaPrint } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import { FaTruckFast } from "react-icons/fa6";
import { useNavigate, Link } from "react-router-dom";
import "../Styling/rawleads.css";
import { useAuth } from "../Context/AuthContext";

import { getInvoiceData } from '../Api/ViewPostedInvoice';
const ViewUnPostedInvoice = () => {
  
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal,setshowCancelModal]=useState(false);
  const [showPostModal,setshowPostModal]=useState(false);
  const [showCustomerModal,setShowCustomerModal]=useState(false);
  const [itemModal,setShowItemModal]=useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [cancellingInvoice, setcancellingInvoice] = useState(null);
  const [postingInvoice,setPostingInvoice]=useState(null);
  const [formData, setFormData] = useState({});
  const [invoiceData,setInvoiceData]=useState({});
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  // 1) state
  const [showCancelledOnly, setShowCancelledOnly] = useState(false);

// 3) derived list


  const navigate = useNavigate();
  const { user } = useAuth();
  useEffect(() => {
    const loadInvoices = async () => {
      try {
        const data = await fetchUnpostedInvoices(user?.organisationId);
        setInvoices(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching posted Invoices`);
      }
    };

    loadInvoices();
  },[]);
 const handleUpdateStatus = async (invoiceId, remarks = "") => {
  setLoading(prev => ({ ...prev, [invoiceId]: true }));

  try {
    const changedBy = user?.userId ? user.userId.toString() : "27"; // use real user id
    // ensure your API helper supports remarks
    await updateInvoicePostedStatus(invoiceId, changedBy, remarks);
    toast.success(`✅ Invoice ${invoiceId} posted successfully!`);
    setInvoices(prev => prev.filter(invoice => invoice.invoiceId !== invoiceId));
  } catch (error) {
    toast.error(`❌ Error posting invoice ${invoiceId}`);
    console.error("Error updating invoice status:", error);
  } finally {
    setLoading(prev => ({ ...prev, [invoiceId]: false }));
  }
};

  const handleEditClick = (invoice) => {
    //   setEditingInvoice(invoice);
    // setFormData({ ...invoice });
    // setShowModal(true);
    navigate(`/updateInvoice/${invoice}`)
  };

  // const handlePrintClick = (invoiceId) => {
  //   navigate('/invoice', { state: { invoiceId } });
  // };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingInvoice(null);
    setFormData({});
  };
  const handleClose = () => setshowCancelModal(false);
  const handlePostClose=()=>setshowPostModal(false);
  const handlePostNext=()=>{
    setshowPostModal(false);
    setShowCustomerModal(true);
  }
  const handleCustomerNext=()=>{
    setShowCustomerModal(false);
    setShowItemModal(true)
  }
  const handleCustomerClose=()=>{
    setShowCustomerModal(false);
  }
  const handleItemClose=()=>{
    setShowItemModal(false);
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCancelClick=async(invoiceID)=>{
      setshowCancelModal(true);
      setcancellingInvoice(invoiceID);
  }
  const handleCancel=async(invoiceId)=>{
    try {
      const changedBy = user.userId.toString();
      await updateCancelInvoiceStatus(invoiceId, changedBy);
      toast.success(`✅ Invoice ${invoiceId} cancelled successfully!`);
      const data = await fetchUnpostedInvoices();
      setInvoices(data || []);
    } catch (error) {
      toast.error(`❌ Error posting invoice ${invoiceId}`);
      console.error("Error updating invoice status:", error);
    } finally {
      setLoading(prev => ({ ...prev, [invoiceId]: false }));
    }
    setshowCancelModal(false);
  }
  const handlePostClick=async(invoiceId)=>{
    setshowPostModal(true);
    setPostingInvoice(invoiceId);
    const res = await getInvoiceData(invoiceId);
    setInvoiceData(res);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editingInvoice) return;

    try {
      await updateInvoiceHeader(editingInvoice.invoiceId, formData);
      toast.success(`✅ Invoice ${editingInvoice.invoiceId} updated successfully!`);

      // Update the local state with the new data
      setInvoices(prev => prev.map(invoice =>
        invoice.invoiceId === editingInvoice.invoiceId
          ? { ...invoice, ...formData }
          : invoice
      ));

      handleCloseModal();
    } catch (error) {
      toast.error(`❌ Error updating invoice ${editingInvoice.invoiceId}`);
      console.error("Error updating invoice:", error);
    }
  };
  const filteredInvoices = showCancelledOnly
  ? invoices.filter(inv => inv.cancelled_Indicator === "Yes")
  : invoices;
  return (
    <>
      <div className="main-content expand">
        <Container fluid className="list-container">
          {/* Header Section with RawLeads styling */}
          <div className="lead-dashboard container-fluid mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h4 className="fw-bold">
                  📋 Invoices Management
                </h4>
                <p className="text-muted">
                  View, manage and update Posted invoices
                </p>
              </div>
              <div>
                <Button variant="outline-primary" className="me-2">
                  📊 Export Data
                </Button>
                <Button className="btn-bulk me-2">
                  ⚡ Bulk Actions
                </Button>
                <Button className="btn-assign me-2">
                  🔄 Refresh
                </Button>
     <Form.Check
  type="checkbox"
  id="show-cancelled-only"
  label="Show Cancelled Only"
  className="d-inline-block ms-2"
  checked={showCancelledOnly}
  onChange={(e) => setShowCancelledOnly(e.target.checked)}
  style={{
    transform: "scale(1.2)",    // Increase checkbox size
    cursor: "pointer",          // Pointer on hover
    padding: "20px",            // Extra padding
    fontWeight: "bold"          // ✅ Make label text bold
  }}
/>



              </div>
            </div>

            {/* Stats Section */}
            <div className="d-flex gap-3 mb-4">
              <div className="stat-card">
                <h5 className="text-primary">{invoices.length}</h5>
                <p className="text-muted">Total Posted</p>
              </div>
              <div className="stat-card">
                <h5 className="text-primary">
                  {invoices.filter(inv => inv.transactionType === 'Sales').length}
                </h5>
                <p className="text-muted">Sales Invoices</p>
              </div>
              <div className="stat-card">
                <h5 className="text-primary">
                  {invoices.filter(inv => inv.transactionType === 'Purchase').length}
                </h5>
                <p className="text-muted">Purchase Invoices</p>
              </div>
              <div className="stat-card">
                <h5 className="text-primary">
                  {invoices.filter(inv => moment(inv.invoiceDate).isSame(moment(), 'month')).length}
                </h5>
                <p className="text-muted">This Month</p>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="raw-leads-table">
            {filteredInvoices.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Invoice ID</th>
                    <th>Company Code</th>
                    <th>Invoice Type</th>
                    <th>Category</th>
                    <th>Supply Type</th>
                    <th>Customer Code</th>
                    <th>Project Code</th>
                    <th>Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Salesperson Code</th>
                    <th>Created At</th>
                    <th>Created By</th>
                    <th>Cancelled Status</th>
                    {/*  <th>Changed On Date</th>
                    <th>Changed On Time</th>
                    <th>Changed By</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInvoices.map((invoice, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{invoice.invoiceId.split('-')[0]+invoice.invoiceId.split('-')[5]}</td>
                      <td>{invoice.companyCode}</td>
                      <td>{invoice.transactionType}</td>
                      <td>{invoice.category}</td>
                      <td>{invoice.supplyType || 'N/A'}</td>
                      <td>{invoice.customerCode || 'N/A'}</td>
                      <td>{invoice.projectCode}</td>
                      <td>{invoice.invoiceNumber}</td>
                      <td>{moment(invoice.invoiceDate).format('L')}</td>
                      <td>{invoice.salespersonCode || 'N/A'}</td>
                      <td>{moment(invoice.createdAt).format('L')} at {moment(invoice.createdAt).format('LTS')}</td>
                      <td>{invoice.createdAt}</td>
                      <td>{invoice.cancelled_Indicator}</td>
                      {/*  <td>{invoice.changedOnDate ? moment(invoice.changedOnDate).format('L') : 'N/A'}</td>
                      <td>{invoice.changedOnTime || 'N/A'}</td>
                      <td>{invoice.changedBy || 'N/A'}</td> */}
                      <td>
                        <div className="d-flex gap-2">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleEditClick(invoice.invoiceId)}
                            title="Edit Invoice"
                          >
                            <FaPencilAlt />
                          </Button>
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => handlePostClick(invoice.invoiceId)}
                            disabled={invoice.cancelled_Indicator==="Yes"}
                            title="Mark as Posted"
                          >
                            {loading[invoice.invoiceId] ? (
                              <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            ) : (
                              <FaCheck />
                            )}
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={()=>handleCancelClick(invoice.invoiceId)}
                            disabled={invoice.cancelled_Indicator==="Yes"}
                            title="Mark as Cancelled"
                          >
                            {loading[invoice.invoiceId] ? (
                              <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            ) : (
                              <FaTimes />
                            )}
                          </Button>
                          <Button
                            variant="outline-info"
                            title="Print Invoice"
                          >
                            <Link to={`/invoice/${invoice.invoiceId}`}>
                              <FaPrint />
                            </Link>

                          </Button>
                          <Button
                            variant="outline-info"
                            title="Dispatch Invoice"
                          >
                            <Link to={`/invoice/dispatchdetails/${invoice.invoiceId}`}>
                              <FaTruckFast />
                            </Link>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) :   (
              <p className="no-data text-center py-4">
                {showCancelledOnly ? "No cancelled invoices found." : "No invoices found."}
              </p>
              )}
          </div>
        </Container>

        {/* Edit Modal */}
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit Invoice: {editingInvoice?.invoiceId}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="companyCode"
                      value={formData.companyCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Invoice Type</Form.Label>
                    <Form.Control
                      type="text"
                      name="transactionType"
                      value={formData.transactionType || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Category</Form.Label>
                    <Form.Control
                      type="text"
                      name="category"
                      value={formData.category || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Supply Type</Form.Label>
                    <Form.Control
                      type="text"
                      name="supplyType"
                      value={formData.supplyType || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Customer Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="customerCode"
                      value={formData.customerCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="projectCode"
                      value={formData.projectCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Invoice Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="invoiceNumber"
                      value={formData.invoiceNumber || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Invoice Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="invoiceDate"
                      value={formData.invoiceDate ? moment(formData.invoiceDate).format('YYYY-MM-DD') : ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Salesperson Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="salespersonCode"
                      value={formData.salespersonCode || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Changed By</Form.Label>
                    <Form.Control
                      type="text"
                      name="changedBy"
                      value={formData.changedBy || ''}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* Cancel Modal */}
        <Modal show={showCancelModal} onHide={handleClose} >
        <Modal.Header closeButton>
          <Modal.Title >Confirm Cancellation</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="danger" onClick={()=>handleCancel(cancellingInvoice)}>
            Yes, Cancel
          </Button>
        </Modal.Footer>
         </Modal>
         {/* Post Modal */}
        <Modal show={showPostModal} onHide={handlePostClose} >
        <Modal.Header closeButton>
          <Modal.Title >Confirm Posting of Invoice of "{invoiceData?.invoice?.invoiceId}"</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePostClose}>
            No
          </Button>
          <Button variant="danger" onClick={handlePostNext}>
            Yes, Post
          </Button>
        </Modal.Footer>
         </Modal>

         {/* Customer Modal */}
       <Modal show={showCustomerModal} onHide={handleCustomerClose} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Confirm Customer of current Invoice</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p className="text-muted">
      Please verify customer & shipping details before posting the invoice.
    </p>

    <Row className="mb-3">
      <Col md={6}>
        <h6>Customer</h6>
        <hr />
        <p><strong>Code:</strong> {invoiceData?.customer?.code}</p>
        <p><strong>Name:</strong> {invoiceData?.customer?.name}</p>
        <p><strong>Short Name:</strong> {invoiceData?.customer?.shortNames}</p>
        <p><strong>Company Code:</strong> {invoiceData?.customer?.companyCode}</p>
        <p><strong>Organisation Id:</strong> {invoiceData?.customer?.organisationId}</p>
        <p><strong>GST No:</strong> {invoiceData?.customer?.gstno}</p>
        <p><strong>PAN:</strong> {invoiceData?.customer?.pan}</p>
        <p><strong>Mobile:</strong> {invoiceData?.customer?.mobileCountrycode} {invoiceData?.customer?.mobileNumber}</p>
      </Col>

      <Col md={6}>
        <h6>Customer Address</h6>
        <hr />
        <p>
          {invoiceData?.customer?.address1} {invoiceData?.customer?.address2 && `, ${invoiceData.customer.address2}`} {invoiceData?.customer?.address3 && `, ${invoiceData.customer.address3}`}
        </p>
        <p><strong>City:</strong> {invoiceData?.customer?.cityName}</p>
        <p><strong>Region:</strong> {invoiceData?.customer?.regionName}</p>
        <p><strong>District:</strong> {invoiceData?.customer?.districtName}</p>
        <p><strong>Pin Code:</strong> {invoiceData?.customer?.pinCode}</p>
        <p><strong>Country:</strong> {invoiceData?.customer?.countryCode}</p>
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <h6>Shipping Address</h6>
        <hr />
        <p><strong>Shipping ID:</strong> {invoiceData?.shipping?.shippingAddressId}</p>
        <p><strong>Name:</strong> {invoiceData?.shipping?.name}</p>
        <p>
          {invoiceData?.shipping?.address1} {invoiceData?.shipping?.address2 && `, ${invoiceData.shipping.address2}`} {invoiceData?.shipping?.address3 && `, ${invoiceData.shipping.address3}`}
        </p>
        <p><strong>Pin Code:</strong> {invoiceData?.shipping?.pinCode}</p>
        <p><strong>Created By:</strong> {invoiceData?.shipping?.createdBy}</p>
        <p><strong>Created On:</strong> {invoiceData?.shipping?.createdOnDate ? moment(invoiceData.shipping.createdOnDate).format("L") : ""} {invoiceData?.shipping?.createdOnTime && `at ${invoiceData.shipping.createdOnTime}`}</p>
      </Col>

      <Col md={6}>
        <h6>Shipping Codes</h6>
        <hr />
        <p><strong>Region Code:</strong> {invoiceData?.shipping?.regionCode}</p>
        <p><strong>District Code:</strong> {invoiceData?.shipping?.districtCode}</p>
        <p><strong>Tehsil Code:</strong> {invoiceData?.shipping?.tehsilCode}</p>
        <p><strong>City Code:</strong> {invoiceData?.shipping?.cityCode}</p>
        <p><strong>Invoice Id:</strong> {invoiceData?.shipping?.invoiceId}</p>
      </Col>
    </Row>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={handleCustomerClose}>
      No
    </Button>

     <Button variant="danger" onClick={handleCustomerNext}>
            Yes, Post
          </Button>
  </Modal.Footer>
        </Modal>

        {/* {Item Model} */}

      <Modal show={itemModal} onHide={handleItemClose} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      Confirm Items of Invoice "{invoiceData?.invoice?.invoiceId}"
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p className="text-muted">Please verify items before posting the invoice.</p>

    <Table bordered hover responsive size="sm">
      <thead>
        <tr>
          <th>#</th>
          <th>Item Code</th>
          <th>Item Name</th>
          <th>Batch</th>
          <th>Qty</th>
          <th>Unit</th>
          <th>Price</th>
          <th>CGST %</th>
          <th>SGST %</th>
          <th>Gross Value</th>
          <th>Expiry</th>
        </tr>
      </thead>
      <tbody>
        {invoiceData?.items?.map((it, idx) => (
          <tr key={it.invoiceItem.itemId}>
            <td>{idx + 1}</td>
            <td>{it.invoiceItem.item}</td>
            <td>{it.itemName}</td>
            <td>{it.invoiceItem.batchId}</td>
            <td>{it.invoiceItem.quantity}</td>
            <td>{it.invoiceItem.unitCode}</td>
            <td>{it.invoiceItem.price}</td>
            <td>{it.invoiceItem.cgst}</td>
            <td>{it.invoiceItem.sgst}</td>
            <td>{it.invoiceItem.grossValue}</td>
            <td>
              {it.expiryDate
                ? moment(it.expiryDate).format("MM/YYYY")
                : "—"}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={handleItemClose}>
      No
    </Button>
<Button
  variant="danger"
  onClick={() => {
    // close items modal and open remarks modal
    handleItemClose();
    setShowRemarksModal(true);
    setRemarks(""); // reset previous remarks
  }}
  disabled={loading[invoiceData?.invoice?.invoiceId]}
>
  {loading[invoiceData?.invoice?.invoiceId] ? (
    <div className="spinner-border spinner-border-sm" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  ) : (
    "Yes, Post"
  )}
</Button>

  </Modal.Footer>
</Modal>
{/* Remarks Modal - add this after the Item Modal */}
<Modal show={showRemarksModal} onHide={() => setShowRemarksModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Enter Remarks before Posting</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>
      <Form.Group controlId="remarksTextarea" className="mb-3">
        <Form.Label>Remarks</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="Add any remarks for this invoice..."
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
      </Form.Group>
    </Form>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowRemarksModal(false)}>
      Cancel
    </Button>

    <Button
      variant="danger"
      onClick={async () => {
        // call posting with remarks
        await handleUpdateStatus(invoiceData?.invoice?.invoiceId, remarks);
        setShowRemarksModal(false);
      }}
      disabled={loading[invoiceData?.invoice?.invoiceId]}
    >
      {loading[invoiceData?.invoice?.invoiceId] ? (
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      ) : (
        "Post with Remarks"
      )}
    </Button>
  </Modal.Footer>
</Modal>




      </div>
    </>
  );
};

export default ViewUnPostedInvoice;